module.exports = __webpack_public_path__ + "static/img/crossword.9aea33b5.png";